// macAddress filter -- formats a 12-character string as a MAC address. The default separator is a colon.
//
//    {{ address | macAddress : separator }}

angular.module('app.filters').filter('macAddress', ($filter) => {
  'ngInject';
  return (input, separator = '-') => {
    return input
      .toUpperCase()
      .match(/.{1,2}/g)
      .join(separator);
  };
});



// WEBPACK FOOTER //
// ./app/filters/mac-address.js